import { render } from "./TeamMarquee.vue?vue&type=template&id=3074a8c0&scoped=true"
import script from "./TeamMarquee.vue?vue&type=script&lang=js"
export * from "./TeamMarquee.vue?vue&type=script&lang=js"

import "./TeamMarquee.vue?vue&type=style&index=0&id=3074a8c0&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3074a8c0"]])

export default __exports__